import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Promise from 'babel-runtime/core-js/promise';

import _ from 'lodash';
import productConfig from '../components/product-config.vue';
import trafficConfig from './traffic-config.vue';
import featureTagConfig from './feature-tag-config.vue';
import creativeDirectionConfig from './creative-direction-config.vue';
import typeConfig from './interactive-type-config.vue';
// import devConfig from './dev-config.vue'
import schemeConfig from './scheme-config.vue';
import ImplementWay from './implement-way.vue';
import ActionBar from '../components/action-bar.vue';
import { fetchInteractiveConfigure, submitInteractiveConfigure, submitInteractivePlan } from '@/api/demand/interactive';
import { getAppTagList } from '@/api/system/app-tag.js';
import JSONParse from '@/utils/JSONParse';
import indexPathByName from '@/utils/index-path-by-name';

export default {
  components: {
    productConfig: productConfig,
    trafficConfig: trafficConfig,
    typeConfig: typeConfig,
    schemeConfig: schemeConfig,
    ActionBar: ActionBar,
    // devConfig,
    creativeDirectionConfig: creativeDirectionConfig,
    featureTagConfig: featureTagConfig,
    ImplementWay: ImplementWay
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    configureData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formConfig: {
        labelWidth: '120px',
        size: 'mini'
      },
      loading: true,
      data: {
        id: this.$route.params.id,
        products: [],
        creation_tags: [],
        tag_ids: [],
        plan_attachment: '',
        design_attachment: '',
        channels: [],
        category_id: '',
        creative_id: '',
        // 产品标签
        appTag: '',
        creative_name: '',
        // 特征标签数据
        featureTagData: [],
        app_cat_ids: '',
        // 特征标签
        material_tag_ids: '',
        fetch_data: false,
        demand: {},
        enable_i18n: '' // 是否通过代码字实现：1 是， 2 否，有一部分数据可能没有这个字段
      },
      autoMaterialTag: '',
      materialTagNames: '',
      oldData: {}, // 存储getInfo拿到的配置
      submitButtonParams: {
        loading: false,
        text: '提交'
      },
      schemeValue: {},
      formDisabled: false
    };
  },

  computed: {
    // 非自研
    otherSource: function otherSource() {
      if (this.oldData && this.oldData.demand) {
        return this.oldData.demand.material_source === 1 || this.oldData.demand.material_source === 3;
      }
      return false;
    },
    isGameByAppCatId: function isGameByAppCatId() {
      var _this = this;

      var list = [{ id: 8, name: '动作' }, { id: 9, name: '角色扮演' }, { id: 10, name: '休闲' }, { id: 11, name: '策略' }, { id: 12, name: '棋牌' }, { id: 13, name: '音乐' }, { id: 14, name: '益智' }, { id: 15, name: '体育' }, { id: 16, name: 'AVG' }];
      return list.some(function (item) {
        return Number(_this.data.app_cat_ids) === item.id;
      });
    },
    isPlayable2D3D: function isPlayable2D3D() {
      var _this2 = this;

      var list = [2, 3];
      var sign = list.some(function (val) {
        return Number(_this2.data.category_id === val);
      });
      // 属于playable2d或者3d
      return sign;
    },
    isConfigByPlanner: function isConfigByPlanner() {
      return this.data.demand.status === 'confirmed';
    },
    isConfigByDesigner: function isConfigByDesigner() {
      return ['planned', 'dev_unassigned', 'dev_confirmed', 'dev_ongoing', 'dev_rejected'].indexOf(this.data.demand.status) !== -1;
    },

    // 只有设计师在指定状态下，并且是game类型、2/3D的自研素材和有创意方向的需求，才允许显示特征标签
    isShowFeatureTag: function isShowFeatureTag() {
      return !!(this.isGameByAppCatId && this.isPlayable2D3D && !this.otherSource && this.data.creative_id);
    },

    // 「素材来源」为「内部制作」，「业务场景」为「模板制作」的需求，不再需要创建创意方向
    // 因为历史素材还需要显示，所以只有满足以上条件，并且没有创意方向id 的时候才不显示
    isHideCreativeDirection: function isHideCreativeDirection() {
      if (this.oldData && this.oldData.demand) {
        return this.oldData.demand.material_source === 2 && this.oldData.demand.biz_scenario === 3 && this.oldData.demand.creative_id === 0 || this.oldData.demand.biz_scenario === 5;
      }
      return false;
    }
  },
  methods: {
    updateFeatureTag: function updateFeatureTag(tag) {
      this.data.material_tag_ids = tag;
    },
    updateAutoMaterialTag: function updateAutoMaterialTag(tag) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.autoMaterialTag = tag;
      });
    },
    submit: function submit() {
      var _this4 = this;

      var promiseArray = [];
      // 只有配置美术资源的时候，才做校验
      if (this.isConfigByDesigner && this.$refs['productForm']) {
        this.$refs['productForm'].forEach(function (e) {
          promiseArray.push(e.validate());
        });
      }
      if (this.$refs['trafficForm']) {
        this.$refs['trafficForm'].forEach(function (e) {
          promiseArray.push(e.validate());
        });
      }
      if (this.$refs['planFileForm']) {
        promiseArray.push(this.$refs.planFileForm.validate());
      }
      if (this.$refs['designFileForm']) {
        promiseArray.push(this.$refs.designFileForm.validate());
      }
      if (this.isGameByAppCatId && this.isPlayable2D3D && !this.otherSource) {
        this.$refs['featureTagForm'] && promiseArray.push(this.$refs['featureTagForm'].validate());
      }
      // this.$refs['devForm'] &&
      //   promiseArray.push(this.$refs['devForm'].validate())
      this.$refs['typeForm'] && promiseArray.push(this.$refs['typeForm'].validate());
      if (!this.otherSource) {
        this.$refs['creativeDirectionForm'] && promiseArray.push(this.$refs['creativeDirectionForm'].validate());
      }
      _Promise.all(promiseArray).then(function (res) {
        // 先保存app信息，再提交整体策划案
        _this4.submitAppInfo();
      }).catch(function (res) {
        console.log(res);
      });
    },
    submitAppInfo: function submitAppInfo() {
      var _this5 = this;

      this.loading = true;
      var promiseArray = [];
      // 只有设计师配置美术资源时才会保存app信息
      if (this.isConfigByDesigner && this.$refs['productForm']) {
        this.$refs['productForm'].forEach(function (e) {
          if (!e.readOnly) {
            promiseArray.push(e.saveAppInfo());
          }
        });
      }
      console.log('校验通过');
      if (promiseArray.length) {
        _Promise.all(promiseArray).then(function (res) {
          _this5.submitConfigure();
        }).catch(function (res) {
          console.log(res);
        });
      } else {
        this.submitConfigure();
      }
    },
    getFeatureTagData: function getFeatureTagData() {
      var _this6 = this;

      this.loading = true;
      getAppTagList({
        type: 2
      }).then(function (res) {
        var list = _.get(res, 'data.data.tag.sub_tags', []);
        _this6.data.featureTagData = list;
      }).catch(function () {
        _this6.loading = false;
      });
    },
    cookSubmitData: function cookSubmitData() {
      var data = _.cloneDeep(this.data);
      data.channels.forEach(function (item) {
        item.category_id = Number(data.category_id);
      });
      data = _.omit(data, ['products', 'creation_tags', 'fetch_data', 'category_id', 'creative_name', 'featureTagData', 'appTagData', 'appTag', 'demand']);
      return data;
    },
    submitConfigure: function submitConfigure() {
      var _this7 = this;

      this.loading = true;
      var postData = this.cookSubmitData();
      if (postData.plan_attachment === this.oldData.plan_attachment) {
        postData = _.omit(postData, ['plan_attachment']);
      }
      if (postData.design_attachment === this.oldData.design_attachment) {
        postData = _.omit(postData, ['design_attachment']);
      }
      var submitPromise = void 0;
      if (this.isConfigByPlanner) {
        submitPromise = submitInteractivePlan;
        postData = _.pick(postData, ['id', 'plan_attachment', 'estimated_time', 'install_return_action']);
      } else {
        submitPromise = submitInteractiveConfigure;
        postData = _.pick(postData, ['id', 'design_attachment', 'material_tag_ids', 'creative_id', 'creative_spec', 'channels', 'meta_pl', 'meta_cl']);
      }
      if (this.isHideCreativeDirection) {
        postData = _.omit(postData, ['creative_id']);
      }
      submitPromise(postData).then(function (res) {
        _this7.loading = false;
        _this7.$message({
          message: '配置成功',
          type: 'success'
        });
        _this7.$router.back(-1);
      }).catch(function (err) {
        // 特殊处理创意方向重复提示
        var list = err.message.split('\n');
        if (list.length > 1) {
          var message = list.map(function (item) {
            return '<div style="line-height: 1.3em;">' + item + '</div>';
          }).join('');
          var msgBox = _this7.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: message,
            duration: 0
          });
          setTimeout(function () {
            msgBox.close();
          }, 5000);
        } else {
          _this7.$message({
            type: 'error',
            message: err.message
          });
        }
        _this7.loading = false;
      });
    },
    getConfigure: function getConfigure() {
      var _this8 = this;

      this.loading = true;
      fetchInteractiveConfigure({
        id: this.$route.params.id
      }).then(function (res) {
        var configureData = res.data.data;
        _this8.fillConfigure(configureData);
      }).catch(function () {
        _this8.loading = false;
      });
    },
    fillConfigure: function fillConfigure(configureData) {
      this.loading = false;
      this.oldData = configureData;
      this.data.demand = configureData.demand;
      this.data.products = configureData.demand.products;
      this.data.channels = configureData.channels;
      this.data.creation_tags = configureData.creation_tags;
      this.data.category_id = configureData.channels ? configureData.channels[0].category_id : '';
      this.data.creative_id = configureData.demand.creative_id;
      this.data.creative_name = configureData.demand.creative_name;
      this.data.material_tag_ids = configureData.demand.material_tag_ids;
      this.data.enable_i18n = configureData.demand.enable_i18n;
      this.data.estimated_time = configureData.demand.estimated_time;
      this.autoMaterialTag = configureData.demand.material_tag_ids || '';
      if (configureData.demand.material_tag_names) {
        this.materialTagNames = configureData.demand.material_tag_names;
      }
      if (configureData.creation_tags && configureData.creation_tags.length) {
        this.data.tag_ids = configureData.creation_tags.map(function (e) {
          return e.id;
        });
      } else {
        this.data.tag_ids = [];
      }
      this.data.design_attachment = configureData.design_attachment_url;
      this.data.plan_attachment = configureData.plan_attachment_url;
      this.data.install_return_action = configureData.install_return_action || '';
      this.data.creative_spec = configureData.creative_spec;
      this.data.meta_pl = configureData.meta_pl;
      this.data.meta_cl = configureData.meta_cl;
      // 研发中的时候。不允许改channel和创意标签
      var disabledStatus = ['dev_ongoing', 'dev_unassigned', 'dev_confirmed'];
      if (disabledStatus.indexOf(configureData.demand.status) !== -1) {
        this.formDisabled = true;
      } else {
        this.formDisabled = false;
      }
      if (this.readOnly) {
        this.formDisabled = true;
      }
      // 特殊标识，组件里面通过监听该字段填充表格
      this.data.fetch_data = true;
    },
    handleUpdateAction: function handleUpdateAction(action) {
      var actionDetail = JSONParse(action);
      var targetChannel = this.data.channels.find(function (item) {
        return item.channel_id === 21;
      });
      if (targetChannel) {
        targetChannel.actions = actionDetail || {};
        if (this.$refs['trafficForm']) {
          this.$refs['trafficForm'].forEach(function (e) {
            e.fillForm();
          });
        }
      }
    },
    updateFeatureTagBySpec: function updateFeatureTagBySpec(val) {
      var _this9 = this;

      var tagTargetValue = {};
      var addIdToTargetValue = function addIdToTargetValue(name, index) {
        // 只获取当前下序的 tagData 是否有命中的索引路径
        var targetTagData = [_this9.data.featureTagData[index]];
        var targetPath = indexPathByName(name, targetTagData);
        if (targetPath.length) {
          var key = targetPath[0];
          var value = targetPath[targetPath.length - 1];
          if (tagTargetValue[key]) {
            tagTargetValue[key] += ',' + value;
          } else {
            tagTargetValue[key] = value;
          }
        }
      };
      // 获取 path 之后，只取头尾 id 即可选取选项
      val.forEach(function (itemName, index) {
        if (itemName.indexOf('/') === -1) {
          addIdToTargetValue(itemName, index);
        } else {
          itemName.split('/').forEach(function (name) {
            addIdToTargetValue(name, index);
          });
        }
      });
      this.updateAutoMaterialTag(_JSON$stringify(tagTargetValue));
    }
  },
  mounted: function mounted() {
    this.getFeatureTagData();
    if (this.configureData && !_.isEmpty(this.configureData)) {
      this.fillConfigure(this.configureData);
    } else {
      this.getConfigure();
    }
  }
};